import { Button, Grid, makeStyles } from '@material-ui/core'
import { CancelOutlined, Save } from '@material-ui/icons';
import React, { useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch } from 'react-redux';
import { enviarUsuarioVentanilla } from '../../../actions/tesoreria/usuariosOspeDirectoActions';

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormUsuariosOspeDirecto = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { formData } = props;
    const [email, setEmail] = useState(formData?.usuarioVentanilla)

    const handleSave = (e) => {
        e.preventDefault()
        dispatch(enviarUsuarioVentanilla(formData.idEfectorRed, email, formData.usuarioVentanilla, formData.passwordVentanilla))
        props.cerrarModal();
    };

    console.log(formData)
    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Email"
                        name="email"
                        value={email}
                        type='email'
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El email es requerido"]}
                    />
                </Grid>
                <Grid container className={classes.botonera}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >

                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelOutlined />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<Save />}
                                type="submit"
                                style={{ marginLeft: "0.5rem" }}
                            >
                                ENVIAR 
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
